<template>
  <div class="class-manage-page">
    <el-card>
      <el-form :model="filter" inline size="small">
        <el-form-item label="班级名称">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称" clearable />
        </el-form-item>
        <el-form-item label="班级类型">
          <el-select v-model="filter.courseType" placeholder="请选择班级类型" clearable>
            <el-option label="基础班级" :value="1" />
            <el-option label="标准班级" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="add" v-if="checkAdmin()">新增班级</el-button>
      <el-table :data="classList" border>
        <el-table-column align="center" label="排序号" prop="sortNum" min-width="68" />
        <el-table-column align="center" label="班级名称" prop="skuName" min-width="160" />
        <el-table-column align="center" label="班级类型" prop="courseType" min-width="80">
          <template v-slot="{ row: { courseType } }">
            <span v-if="courseType === 1">基础班级</span>
            <span v-else-if="courseType === 2">标准班级</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="所属项目" prop="projectName" min-width="120" />
        <el-table-column align="center" label="售价" prop="priceSale" min-width="80" />
        <el-table-column align="center" label="升级价" prop="priceUpgrade" min-width="80" />
        <el-table-column align="center" label="底价" prop="basePrice" min-width="80" />
        <el-table-column align="center" label="代理商供货价" prop="priceMin" min-width="80" />
        <el-table-column align="center" label="划线价" prop="priceView" min-width="80" />
        <el-table-column align="center" label="已关联基础必学课程" prop="courseBase" min-width="110" />
        <el-table-column align="center" label="已关联职业方向课程" prop="courseOccupation" min-width="110" />
        <el-table-column align="center" label="班级有效期（天）" prop="validityNum" min-width="100" />
        <el-table-column align="center" label="班级状态" prop="publishFlag" min-width="80">
          <template v-slot="{ row: { publishFlag } }">
            <span v-if="publishFlag === 1">已下架</span>
            <span v-else-if="publishFlag === 2">已上架</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间" prop="lastUpdateDate" min-width="160" />
        <el-table-column align="center" label="最后操作人" prop="lastUpdateName" min-width="100" />
        <el-table-column align="center" label="操作" min-width="220" fixed="right">
          <template v-slot="{ row }">
            <el-button v-if="row.publishFlag === 2 && checkAdmin()" type="text" size="mini" @click="statusAmend(row)">下架</el-button>
            <el-button v-if="row.publishFlag === 1 && checkAdmin()" type="text" size="mini" @click="statusAmend(row)">上架</el-button>
            <el-button v-if="checkAdmin()" type="text" size="mini" @click="edit(row)">编辑</el-button>
            <br>
            <el-button v-if="checkAdmin()" type="text" size="mini" @click="configEnd(row)">配置结业证</el-button>
            <el-button v-if="checkAdmin()" type="text" size="mini" @click="configCertificate(row)">配置合格证</el-button>
            <el-button type="text" size="mini" @click="viewDetail(row)">班级详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px; text-align: center;" :current-page="filter.page" :page-sizes="[10, 20, 30, 50]" :page-size="filter.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>
    <!-- 新增 or 编辑 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
      <el-form :model="classForm" :rules="rules" ref="classForm" label-width="110px" size="small">
        <el-form-item label="班级名称" prop="skuName">
          <el-input v-model="classForm.skuName" maxlength="50" placeholder="请输入班级名称" />
        </el-form-item>
        <el-form-item label="班级类型" prop="courseType">
          <el-select v-model="classForm.courseType" placeholder="请选择班级类型" clearable>
            <el-option label="基础班级" :value="1" />
            <el-option label="标准班级" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="classForm.projectId" placeholder="请选择所属项目" clearable>
            <el-option v-for="item of projectList" :key="item.id" :label="item.projectName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="售价" prop="priceSale">
          <el-input-number v-model="classForm.priceSale" :precision="2" placeholder="请输入售价" :controls="false" />
        </el-form-item>
        <el-form-item v-if="classForm.courseType === 2" label="升级价" prop="priceUpgrade">
          <el-row type="flex" align="middle">
            <el-input-number v-model="classForm.priceUpgrade" :precision="2" placeholder="请输入升级价" :controls="false" />
            <el-tooltip effect="dark" content="学员购买基础班级后升级标准班的价格。">
              <i class="el-icon-question" style="margin-left: 12px" />
            </el-tooltip>
          </el-row>
        </el-form-item>
        <el-form-item label="代理商供货价" prop="priceMin">
          <el-input-number v-model="classForm.priceMin" :precision="2" placeholder="请输入代理商供货价" :controls="false" />
        </el-form-item>
        <el-form-item label="划线价" prop="priceView">
          <el-input-number v-model="classForm.priceView" placeholder="请输入划线价" :controls="false" />
        </el-form-item>
        <el-form-item label="底价" prop="basePrice">
          <el-input-number v-model="classForm.basePrice" placeholder="请输入底价" :controls="false" />
        </el-form-item>
        <el-form-item label="协议模板" prop="contractId">
          <el-select v-model="classForm.contractId" placeholder="请选择协议模板" filterable clearable>
            <el-option v-for="item of dealList" :key="item.id" :label="item.contractName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="主讲老师" prop="classTeacher">
          <el-select v-model="classForm.classTeacher" placeholder="可设置多个" filterable multiple collapse-tags clearable>
            <el-option v-for="item of teachersList" :key="item.userId" :label="item.nickName" :value="String(item.userId)" />
          </el-select>
        </el-form-item>
        <el-form-item label="计划课时数" prop="lesperiodNum">
          <el-input style="width: 220px;" v-model="classForm.lesperiodNum" @input="digitCheck(classForm.lesperiodNum, 'lesperiodNum')" placeholder="请输入计划课时数" />
        </el-form-item>
        <el-form-item label="证书颁发单位" prop="issuingAuthority">
          <el-input v-model="classForm.issuingAuthority" placeholder="请输入证书颁发单位" />
        </el-form-item>
        <el-form-item label="学员基数" prop="buyersBase">
          <el-input-number v-model="classForm.buyersBase" :max="99999999" :controls="false" placeholder="请输入学员基数" />
        </el-form-item>
        <el-form-item label="好评率" prop="applauseRateBase">
          <el-input-number v-model="classForm.applauseRateBase" :min="0" :max="100" :controls="false" placeholder="请输入好评率" />
        </el-form-item>
        <el-form-item label="班级有效期" prop="validityNum">
          <el-row type="flex">
            <el-input-number v-model="classForm.validityNum" :max="9999" :controls="false" />
            <span>（天）</span>
          </el-row>
        </el-form-item>
        <el-form-item label="实操课程天数" prop="numTrainingDay">
          <el-input style="width: 220px;" v-model="classForm.numTrainingDay" @input="digitCheck(classForm.numTrainingDay, 'numTrainingDay')" placeholder="请输入实操课程天数" />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNum">
          <el-input-number v-model="classForm.sortNum" :controls="false" placeholder="请输入排序号" />
        </el-form-item>
        <el-form-item label="班级图片" prop="image">
          <Upload v-model="classForm.image" :isCard="false" :drag="false" class="class-upload">
            <template v-slot:index>
              <img v-if="classForm.image" :src="classForm.image" class="class-image">
              <i v-else class="el-icon-plus upload-ploader-icon" />
            </template>
          </Upload>
        </el-form-item>
        <el-form-item label="班级详情介绍" prop="summary">
          <QuillEditor v-if="dialogVisible" v-model="classForm.summary" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 配置结业证 -->
    <HandleCerCompletion ref="dialogCerCompletion" :editParams='editParams' @success='success'></HandleCerCompletion>
    <!-- 配置合格证 -->
    <HandleCerQualified ref="dialogCerQualified" :editParams='editParams' @success='success'></HandleCerQualified>
    <!-- 班级详情 -->
    <ClassDetail ref="detailEl" :detail="currentDetail" />
  </div>
</template>

<script>
import ClassDetail from './components/classDetail.vue';
import Upload from "@/components/upload.vue";
import QuillEditor from "@/components/QuillEditor/index.vue";

import HandleCerQualified from "./components/handle-cer-qualified.vue";
import HandleCerCompletion from "./components/handle-cer-completion.vue";

import {
  getPageList,
  addClass,
  updateClass
} from '@/api/product/classManage'
import { getPageList as getProjectList } from '@/api/product/project'
import { getTeacherList, getDealList } from '@/api/common'

const rules = {
  skuName: [{ required: true, message: '请输入班级名称', trigger: 'blur' }],
  courseType: [{ required: true, message: '请选择班级类型', trigger: 'change' }],
  projectId: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
  priceSale: [
    { required: true, message: '请输入售价', trigger: 'blur' },
    // { pattren: /^((([0].\d{2}|[1-9]{1,5}.\d{2})))$/, message: '请输入最多8位纯数字、必须精准到小数点后两位', trigger: 'blur' }
  ],
  priceUpgrade: [
    { required: true, message: '请输入升级价', trigger: 'blur' },
    // { pattren: /^((([0].\d{2}|[1-9]{1,5}.\d{2})))$/, message: '请输入最多8位纯数字、必须精准到小数点后两位', trigger: 'blur' }
  ],
  priceMin: [
    { required: true, message: '请输入代理商供货价', trigger: 'blur' },
    // { pattren: /^((([0].\d{2}|[1-9]{1,5}.\d{2})))$/, message: '请输入最多8位纯数字、必须精准到小数点后两位', trigger: 'blur' }
  ],
  priceView: [{ required: true, message: '请输入划线价', trigger: 'blur' }],
  basePrice: [{ required: true, message: '请输入底价', trigger: 'blur' }],
  contractId: [{ required: true, message: '请选择协议模板', trigger: 'change' }],
  validityNum: [
    { required: true, message: '请输入班级有效期', trigger: 'blur' },
  ],
  classTeacher: [{ required: true, message: '请选择主讲老师', trigger: 'blur' }],
  sortNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
  image: [{ required: true, message: '请上传班级图片', trigger: 'blur' }],
  summary: [{ required: true, message: '请输入班级详情介绍', trigger: 'blur' }],
  lesperiodNum: [{ required: true, message: '请输入计划课时数', trigger: 'blur' }],
  numTrainingDay: [{ required: true, message: '请输入实操课程天数', trigger: 'blur' }],
}

export default {
  name: 'ClassManage',
  components: { ClassDetail, Upload, QuillEditor, HandleCerQualified, HandleCerCompletion },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        skuName: null,
        skuType: null
      },
      total: 0,
      classList: [],
      dialogVisible: false,
      title: '',
      editId: null,
      classForm: {
        skuName: null,
        courseType: null,
        projectId: null,
        priceSale: undefined,
        priceUpgrade: undefined,
        priceMin: undefined,
        priceView: undefined,
        basePrice: undefined,
        contractId: null,
        validityNum: undefined,
        buyersBase: undefined,
        applauseRateBase: undefined,
        classTeacher: null,
        sortNum: undefined,
        image: null,
        summary: null,
        lesperiodNum: null,
        issuingAuthority: null,
        numTrainingDay: null
      },
      projectList: [], // 选择项目列表
      teachersList: [], // 选择教师列表
      dealList: [], // 协议列表
      rules,
      currentDetail: {},
      editParams: {}
    }
  },
  created () {
    this.getList()
  },
  methods: {
    digitCheck(payload, value){
      this.$nextTick(() => {
        this.$set(this.classForm, value, payload.replace(/[^0-9]/g, ""));
      });
    },
    configEnd (row) {
      this.editParams = JSON.parse(JSON.stringify(row));
      setTimeout(() => {
        this.showDialog('dialogCerCompletion')
      }, 500);
    },
    configCertificate (row) {
      this.editParams = JSON.parse(JSON.stringify(row));
      setTimeout(() => {
        this.showDialog('dialogCerQualified')
      }, 500);
    },
    showDialog (componentName) {
      this.$refs[componentName].setOpacity(true)
    },
    success () {
      this.editParams = {};
      this.getList()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset () {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = null
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    // 列表
    async getList () {
      const res = await getPageList(this.filter)
      if (res.code !== 0) return this.$message.error(res.message)
      this.classList = res.data.records
      this.total = +res.data.total
    },
    add () {
      this.title = '新增班级'
      this.handleGetProjectList()
      this.handleGetTeacherList()
      this.handleGetDealList()
      this.dialogVisible = true
    },
    // 修改状态
    statusAmend (row) {
      let operateStatus = ''
      let publishFlag = 1
      switch (row.publishFlag) {
        case 1:
          operateStatus = '上架'
          publishFlag = 2
          break
        case 2:
          operateStatus = '下架'
          publishFlag = 1
          break
      }
      this.$confirm(`确认${operateStatus}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateClass({ id: row.id, publishFlag })
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success(`${operateStatus}成功!`)
        this.getList()
      })
    },
    // 点击编辑
    edit (row) {
      this.title = '编辑班级'
      this.editId = row.id
      this.dialogVisible = true
      // this.$refs.classForm && this.$refs.classForm.resetFields()
      this.classForm = {
        skuName: row.skuName,
        courseType: row.courseType,
        projectId: row.projectId,
        priceSale: row.priceSale,
        priceUpgrade: row.priceUpgrade,
        priceMin: row.priceMin,
        priceView: row.priceView,
        basePrice: row.basePrice,
        contractId: row.contractId,
        validityNum: row.validityNum,
        buyersBase: row.buyersBase,
        applauseRateBase: row.applauseRateBase,
        classTeacher: [],
        sortNum: row.sortNum,
        image: row.image,
        summary: row.summary,
        lesperiodNum: row.lesperiodNum,
        issuingAuthority: row.issuingAuthority,
        numTrainingDay: row.numTrainingDay
      }
      if (row.teachers) {
        this.classForm.classTeacher = row.teachers.split(',')
      }
      this.handleGetProjectList()
      this.handleGetTeacherList()
      this.handleGetDealList()
    },
    // 提交
    submit () {
      this.$refs.classForm.validate(async (valid) => {
        if (valid) {
          const params = { ...this.classForm }
          if (this.classForm.courseType === 1) {
            delete this.classForm.priceUpgrade
          }
          // 校验价格
          if (params.basePrice <= 0) {
            this.$message.warning('底价不可小于0，请重新填写!')
            return
          }
          // 校验价格
          if (params.basePrice > params.priceSale) {
            this.$message.warning('底价不可高于售价，请重新填写!')
            return
          }
          if (params.basePrice > params.priceUpgrade) {
            this.$message.warning('升级价不可低于底价，请重新填写!')
            return
          }
          if (params.classTeacher && params.classTeacher.length !== 0) {
            params.teachers = params.classTeacher.join(',')
          }
          delete params.classTeacher
          if (params.numTrainingDay >= params.validityNum) {
            return this.$message.warning('实操课程天数不能大于等于班级有效期天数')
          }
          let res
          if (this.editId) {
            // 编辑
            params.id = this.editId
            res = await updateClass(params)
          } else {
            // 新增
            res = await addClass(params)
          }
          if (res.code !== 0) return this.$message.error(res.message)
          this.$message.success('操作成功!')
          this.handleClose()
          this.search()
        }
      })
    },
    viewDetail (row) {
      this.currentDetail = row
      this.$refs.detailEl.index = '1'
      this.$refs.detailEl.dialogVisible = true
    },
    handleClose () {
      this.title = null
      this.editId = null
      this.classForm = this.$options.data().classForm
      this.dialogVisible = false
    },
    handleSizeChange (v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange (v) {
      this.filter.page = v
      this.getList()
    },
    // 获取教师列表
    handleGetProjectList () {
      getProjectList({ page: 1, limit: -1, status: 1 }).then(({ code, data }) => {
        if (code === 0 && data) {
          this.projectList = data.records || []
        }
      })
    },
    handleGetTeacherList () {
      getTeacherList({ page: 1, limit: -1, okTeacher: 1, status: 1 }).then(({ code, data }) => {
        if (code === 0 && data) {
          this.teachersList = data.records || []
        }
      })
    },
    // 获取协议列表
    handleGetDealList () {
      getDealList().then(({ code, data }) => {
        if (code === 0) {
          this.dealList = data || []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.class-upload {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
  }
  .upload-ploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .class-image {
    width: 120px;
    height: 120px;
    display: block;
  }
}
</style>
